import type { PrepareSocialAuthenticationInput } from '@/lib/auth/social-auth'

type PrepareSocialAuthenticationResponse = {
  startPath?: unknown
}

export async function requestSocialAuthenticationStartPath(
  input: PrepareSocialAuthenticationInput,
  fetcher: typeof fetch = fetch,
) {
  const response = await fetcher('/api/auth/social/prepare', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
    credentials: 'same-origin',
  })

  if (!response.ok) {
    throw new Error('Could not prepare social authentication')
  }

  const payload = (await response.json()) as PrepareSocialAuthenticationResponse
  const expectedPath = `/auth/social/start?flow=${encodeURIComponent(input.nonce)}`
  if (payload.startPath !== expectedPath) {
    throw new Error('Invalid social authentication start path')
  }

  return payload.startPath
}
